import React from 'react';
import classNames from 'classnames';
import { Icon }  from '@beisen/chaos-ui';
import * as findAreaPath from './findAreaPath';
import { addEnNavClassName } from '../../util/ui';
class AreaItem extends React.Component {
    constructor(props) {
        super(props);
        this.onTouchTap = this.onTouchTap.bind(this);
    }
    onTouchTap(event) {
        event.preventDefault();
        let { onTouchTap, selectIds, Id } = this.props;
        onTouchTap && onTouchTap(Object.assign({}, this.props, {
            'selected': selectIds.indexOf(Id + ',') >= 0
        }));
    }
    getCheckBox(dataLevel, checked) {
        if (dataLevel != 3) {
            return null;
        };
        if (checked) {
            if (this.props.singleSelect) {
                return <Icon size='small' icon='m-sys-singlebox' active={true} />;
            }
            return <Icon size='small' icon='m-sys-checkbox-active' />;
        }
        if (this.props.singleSelect) {
            return null;
        }
        return <Icon size='small' icon='m-sys-checkbox' className="uncheck-color" />;
    }
    render() {
        let { Name, dataLevel,  selectAreas, Id, expandIds, dataIndex, initAllData } = this.props;
        const isExpand = expandIds === Id || (dataIndex === 0 && expandIds === 'first');
        let selectedPath;
        //所有已选择的地区路径 [[level1,level2,level3]，[level1,level2,level3],[level1,level2,level3]]
        if (selectAreas.length == 0) {
            selectedPath = [];
        } else if (selectAreas.length > 1) {
            selectAreas.forEach((item, index) => {
                if (index == 0) {
                    selectedPath = [findAreaPath.findAreaPath(initAllData, item.Id).path];
                } else {
                    selectedPath.push(findAreaPath.findAreaPath(initAllData, item.Id).path);
                }
            });
        } else {
            selectedPath = [findAreaPath.findAreaPath(initAllData, selectAreas[0].Id).path];
        }
        let levelGroup;
        // [[level1,level1,level1,...],[level2,level2,level2,..],[level3,level3,..]]
        let hasCheckedChild = false; //判断是否有被选中的子级 有显示蓝点 没有不显示
        if (selectAreas.length > 0) {
            selectedPath.forEach((item, index) => {
                if (index == 0) {
                    levelGroup = [[item[0]], [item[1]], [item[2]]];
                } else {
                    levelGroup[0].push(item[0]);
                    levelGroup[1].push(item[1]);
                    levelGroup[2].push(item[2]);
                }
            });
            if (dataLevel == 1) {
                levelGroup[0].forEach(item => {
                    if (item == Id) {
                        hasCheckedChild = true;
                    }
                });
            }
            if (dataLevel == 2) {
                levelGroup[1].forEach(item => {
                    if (item == Id) {
                        hasCheckedChild = true;
                    }
                });
            }
        }
        let isSelected;
        isSelected = selectAreas.find(item => {
            return item.Id == Id;
        });
        const enNavButtonClass = addEnNavClassName();
        return (
            <div className={
                classNames('area-item',  enNavButtonClass, {
                    'border-b': dataLevel == 3,
                    'area-item-expand': !this.props.hasClear && ((isExpand && dataLevel != 3) || (isSelected && dataLevel == 3))
                })
            }
                onTouchTap={this.onTouchTap}
            >
                <span className={
                    classNames({
                        'em-sep': (!Id || expandIds !== Id || isExpand) && dataLevel != 3,
                        'em-badge': hasCheckedChild
                    })
                }
                />
                {(isExpand && dataLevel == 2) ? <Icon icon="m-sys-backward" size='small' className="area-icon" /> : null}
                {dataLevel == 3 ? <span className={classNames('area-name', enNavButtonClass)}> {Name} </span> : Name}
                {this.getCheckBox(dataLevel, isSelected)}
            </div>
        );
    }
}
export default AreaItem;



// WEBPACK FOOTER //
// ./src/components/Field_Components/PopArea/AreaItem.js